<template>
    <div>
        <h1 class="display-heading">Drugs Management (IPH)</h1>

        <div class="row md-mb-0">
            <div class="col-md-6">
                <div class="card mb-3">
                    <div class="card-header">Search Products</div>
                    <div class="card-body">
                        <table class="table table-borderless mb-0">
                            <colgroup>
                                <col width="180" />
                                <col />
                            </colgroup>
                            <!-- <tr>
                                <td class="text-right">Registration Number</td>
                                <td>
                                    <input type="text" class="form-control" placeholder="Enter Registration Number to Search" v-model="filters.registrationNumber" />
                                </td>
                            </tr> -->
                            <tr>
                                <td class="text-right">Product Name</td>
                                <td>

                                    <input type="text" class="form-control" placeholder="Enter Generic Name to Search" v-model="filters.productName" />
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right">Active Ingredient</td>
                                <td>
                                    <input type="text" class="form-control" placeholder="Enter Brand Name to Search" v-model="filters.activeIngredient" />
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <button class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="getFilterDrugs">Search Products</button>
                                    <button class="btn btn-secondary mb-2" @click="clearFilters">Clear Filter</button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="card mb-3">
                    <div class="card-header">Add Products</div>
                    <div class="card-body">
                        <router-link
                            :to="{
                                name: 'pharmacy-drugs-management-new',
                            }"
                            class="btn btn-primary btn-primary-insv mr-2"
                        >
                            Add Single Product
                        </router-link>
                        <router-link
                            :to="{
                                name: 'pharmacy-drugs-management-bulk-upload',
                            }"
                            class="btn btn-primary btn-primary-insv mr-2"
                        >
                            Bulk Upload Products
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-sm table-hover font-sm">
                    <colgroup>
                        <col width="40">
                        <col>
                        <col>
                        <col width="150">
                        <col width="150">
                        <col width="120">
                        <col width="120">
                        <col width="120">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Active Ingredient</th>
                            <th scope="col" class="text-right pr-3">Unit</th>
                            <th scope="col" class="text-right pr-3">
                                Max Retail Price
                            </th>
                            <th scope="col">Added At</th>
                            <th scope="col">Last Updated</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="drugList.length === 0">
                            <td
                                :colspan="columnsCount"
                                class="text-center font-italic"
                            >
                                {{
                                    isTableLoading ? "Loading Data" : "No Data"
                                }}
                            </td>
                        </tr>

                        <tr v-for="(drug, index) in drugList" :key="index">
                            <td scope="row">
                                {{
                                    (pagination.currentPage - 1) *
                                        pagination.pageSize +
                                    index +
                                    1
                                }}
                            </td>
                            <td>
                                {{drug.productName}}
                            </td>
                            <td>
                                {{ drug.activeIngredient }}
                            </td>
                            <td class="text-right pr-3">
                                {{ drug.unit }}
                            </td>
                            <td class="text-right pr-3">
                                {{ drug.retailPrice }}
                            </td>
                            <td>
                                {{ drug.addedAt }}
                            </td>
                            <td>
                                {{ drug.updatedAt }}
                            </td>
                            <td class="text-nowrap">
                                <router-link
                                    :to="{
                                        name: 'pharmacy-drugs-management-detail',
                                        params: {
                                            id: drug.drugId,
                                        },
                                    }"
                                    >View / Edit</router-link
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination
                    v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition"
                >
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    convertDateToDDMMYYYY
} from '@/utilities';
import dataFilter from '@/components/data-filter';
import pagination from '@/components/pagination';
export default {
    'name': 'DrugsList',
    'components': {
        dataFilter,
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getFilterDrugs(false);
            });
        }
    },
    data () {
        return {
            'drugList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'filters': {
                'productName': '',
                'activeIngredient': ''
            },
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 50,
                'scrollPosition': 0
            }
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition =
                this.$refs.tableSection.getBoundingClientRect().top +
                window.scrollY -
                document.querySelector('.top-navigation').clientHeight;
        });

        this.getFilterDrugs();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getFilterDrugs (shouldResetPaging = true) {
            this.isTableLoading = true;

            if (shouldResetPaging) {
                this.pagination.currentPage = 1;
            }

            this.axios
                .post('PharmacyDrug/GetDrugList', {
                    'p': this.pagination.currentPage,
                    'ps': this.pagination.pageSize,
                    'pn': this.filters.productName,
                    'ai': this.filters.activeIngredient
                })
                .then(({ data }) => {
                    this.isTableLoading = false;
                    let pagedResult = data.data;

                    this.pagination.currentPage = pagedResult.p;
                    this.pagination.totalPages = pagedResult.c;

                    let list = pagedResult.l;
                    this.drugList = list.map((drug) => ({
                        'drugId': drug.di,
                        'registrationNumber': drug.rn,
                        'productName': drug.pn,
                        'activeIngredient': drug.ai,
                        'description': drug.de,
                        'unit': drug.u,
                        'retailPrice': drug.rp.toFixed(2),
                        'updatedAt': drug.ua ? convertDateToDDMMYYYY(drug.ua) : '-',
                        'addedAt': drug.ua ? convertDateToDDMMYYYY(drug.aa) : '-'
                    }));
                })
                .catch(({ response }) => {});
        },
        clearFilters () {
            this.filters.productName = '';
            this.filters.activeIngredient = '';

            this.getFilterDrugs();
        }
    }
};
</script>

<style>
</style>
